import config from '@app/config';
import { ElementIdTab, Part, PartProduct, Tab, TabTitle, ButtonId } from '../../types/productSchema';

export const generateTabs = (part: Part | PartProduct) => {
  let newArray = [];

  newArray[Tab.Availability] = {
    title: TabTitle.Availability,
    tabElementId: ElementIdTab.TabAvailability,
  };
  newArray[Tab.ProductSpecs] = {
    title: TabTitle.ProductSpecs,
    tabElementId: ElementIdTab.TabProductSpecs,
  };
  newArray[Tab.ProductReview] = {
    title: TabTitle.ProductReview,
    tabElementId: ElementIdTab.TabProductReview,
  };
  newArray[Tab.Reviews] = {
    title: TabTitle.Reviews,
    tabElementId: ElementIdTab.TabReviews,
    buttonId: ButtonId.Reviews,
  };
  newArray[Tab.FitsTheCar] = {
    title: TabTitle.FitsTheCar,
    tabElementId: ElementIdTab.TabFitsTheCar,
  };
  newArray[Tab.HowToBuy] = {
    title: TabTitle.HowToBuy,
    tabElementId: ElementIdTab.TabHowToBuy,
  };
  newArray[Tab.Analogues] = {
    title: TabTitle.Analogues,
    tabElementId: ElementIdTab.TabAnalogues,
  };

  if (config.safeModeAnaloguesByCartProduct === 'true') {
    newArray = newArray.filter(tab => tab.title !== TabTitle.Analogues);
  }

  if (config.safeModeFitsTheCarByCartProduct === 'true') {
    newArray = newArray.filter(tab => tab.title !== TabTitle.FitsTheCar);
  }

  if (![Part.Tyres, PartProduct.Tyres].includes(part)) {
    newArray = newArray.filter(tab => ![TabTitle.Analogues].includes(tab.title));
  }

  if (![Part.Disks, Part.Tyres, PartProduct.Disks, PartProduct.Tyres].includes(part)) {
    newArray = newArray.filter(tab => ![TabTitle.FitsTheCar].includes(tab.title));
  }

  if (
    ![
      Part.Disks,
      Part.Tyres,
      Part.TruckTires,
      Part.MotoTires,
      Part.Batteries,
      Part.Oils,
      Part.Secrets,
      Part.RelatedProducts,
      PartProduct.Disks,
      PartProduct.Tyres,
      PartProduct.TruckTires,
      PartProduct.MotoTires,
      PartProduct.Batteries,
      PartProduct.Oils,
      PartProduct.Secrets,
      PartProduct.RelatedProducts,
    ].includes(part)
  ) {
    newArray = newArray.filter(tab => ![TabTitle.ProductReview].includes(tab.title));
  }

  if (
    ![
      Part.Disks,
      Part.Tyres,
      Part.TruckTires,
      Part.MotoTires,
      Part.Batteries,
      Part.Oils,
      Part.Secrets,
      Part.RelatedProducts,
      PartProduct.Disks,
      PartProduct.Tyres,
      PartProduct.TruckTires,
      PartProduct.MotoTires,
      PartProduct.Batteries,
      PartProduct.Oils,
      PartProduct.Secrets,
      PartProduct.RelatedProducts,
    ].includes(part)
  ) {
    newArray = newArray.filter(tab => ![TabTitle.ProductSpecs, TabTitle.Reviews].includes(tab.title));
  }

  return newArray;
};
